import { useState } from 'react';
import { TrendingUp, BarChart3 } from 'lucide-react';
import { AgentHeader } from '../../components/layout/AgentHeader';
import { AgentSidebar } from '../../components/layout/AgentSidebar';
import { BottomNav } from '../../components/layout/BottomNav';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/common/Card';
import { Button } from '../../components/common/Button';

const PerformancePage = () => {
  const [period, setPeriod] = useState<'week' | 'month' | 'year'>('month');

  return (
    <div className="min-h-screen bg-gray-50">
      <AgentHeader />

      <div className="flex">
        <AgentSidebar />

        <main className="flex-1 p-4 lg:p-6 pb-20 lg:pb-6">
          <div className="max-w-4xl mx-auto space-y-6">
            {/* Header */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Rendimiento</h2>
              <p className="text-gray-600">Análisis de tu desempeño</p>
            </div>

            {/* Period Selector */}
            <Card variant="bordered">
              <CardContent className="p-4">
                <div className="flex gap-2">
                  {(['week', 'month', 'year'] as const).map((p) => (
                    <Button
                      key={p}
                      variant={period === p ? 'primary' : 'outline'}
                      size="sm"
                      onClick={() => setPeriod(p)}
                    >
                      {p === 'week' ? 'Semana' : p === 'month' ? 'Mes' : 'Año'}
                    </Button>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Performance Chart Placeholder */}
            <Card variant="bordered">
              <CardHeader>
                <CardTitle>Volumen de Transacciones</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="h-64 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg">
                  <div className="text-center text-gray-500">
                    <BarChart3 size={48} className="mx-auto mb-2 opacity-50" />
                    <p>Gráfico de rendimiento</p>
                    <p className="text-sm">(Integrar con Recharts)</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* KPIs */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Card variant="bordered">
                <CardContent className="p-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                      <TrendingUp className="text-primary-600" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Transacciones</p>
                      <p className="text-2xl font-bold text-gray-900">0</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card variant="bordered">
                <CardContent className="p-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-success-100 rounded-lg flex items-center justify-center">
                      <TrendingUp className="text-success-600" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Volumen</p>
                      <p className="text-2xl font-bold text-gray-900">$0</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card variant="bordered">
                <CardContent className="p-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-warning-100 rounded-lg flex items-center justify-center">
                      <TrendingUp className="text-warning-600" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Comisiones</p>
                      <p className="text-2xl font-bold text-gray-900">$0</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </main>
      </div>

      <BottomNav />
    </div>
  );
};

export default PerformancePage;
